import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesHeartFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2c9.625 0 11 1.25 11 10q0 .837-.02 1.585a4 4 0 0 0-1.15-.512c-1.113-.298-2.297-.12-3.324.52-1.015-.646-2.19-.853-3.31-.57-1.696.429-2.996 1.935-2.996 3.91 0 1.784 1.22 3.097 2.184 3.913.443.375.932.725 1.416 1.047-1.096.077-2.355.107-3.8.107-9.625 0-11-1.25-11-10S2.375 2 12 2M6 12.9h6v-1.8H6zm0-4h12V7.1H6z"
                fill="currentColor"
            />
            <path
                d="M14 16.932c0-2.25 2.864-3.223 4.5-.887 1.636-2.336 4.5-1.25 4.5.887 0 1.64-2.01 3.008-3.769 4.078l-.731.44-.708-.426-.786-.49c-1.53-.99-3.006-2.196-3.006-3.602"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesHeartFilledSize24Glyph.displayName = 'CardLinesHeartFilledSize24Glyph';
